import * as React from "react";

import { IPageContainerState } from "@montana/containers/page";
import { DynamicBlocks } from "@montana/blocks/dynamic-blocks.component";

export const StandardView: React.FC<IPageContainerState> = React.memo((props: IPageContainerState): JSX.Element => {

    const { blocks } = props;

    return (
        <div>
            <DynamicBlocks blocks={blocks} isFirstElementOnPage />
        </div>
    );
});
